import React from "react";
import { Table } from "rsuite";
import "../../../../../styles/components/tablas.scss";
//xx
const { Cell } = Table;

export default function DetailActionTableCell({ rowData, ...props }) {
  return (
    <Cell {...props}>
      <span className="text bold-text">{rowData.EmployeeName}</span>
      <br />
      <span className="text"> {rowData.Rut}</span>
    </Cell>
  );
}
